import { defineFcm } from '../shared/factory';

export const FCM_PETITION_STARTED_BY_CLAIMED_NPO_ENABLED = defineFcm('petition_started_by_claimed_npo_enabled')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-dolphin',
		scope: 'petition-service',
		context: 'Start a Petition',
		description:
			'Controls whether a user who has claimed an NPO will have their petition associated with that organization.',
		import: false,
	});
